import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../../ui/alert-dialog';
import { formatTime } from './utils';

/** Confirm cancel of a single booking. */
export function CancelBookingAlertDialog({ open, onOpenChange, onConfirm }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Cancel Booking</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to cancel this booking? Refund policy applies based on cancellation timing.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Keep Booking</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-rose-500 hover:bg-rose-600">
            Cancel Booking
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

/** Confirm leaving a waitlist entry. */
export function LeaveWaitlistAlertDialog({ open, onOpenChange, onConfirm }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Leave Waitlist</AlertDialogTitle>
          <AlertDialogDescription>
            Remove yourself from this waitlist? You'll need to rejoin if you change your mind.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Stay on Waitlist</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-rose-500 hover:bg-rose-600">
            Leave Waitlist
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

/** Confirm a drag-and-drop reschedule. */
export function DragRescheduleAlertDialog({ open, onOpenChange, dragData, onConfirm, onCancel }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Reschedule Booking</AlertDialogTitle>
          <AlertDialogDescription>
            {dragData && (
              <>Reschedule your "{dragData.booking.lane_name}" booking from {formatTime(dragData.booking.start_time)} to {formatTime(dragData.startTime)} on Lane {dragData.laneId}?</>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} className="bg-blue-500 hover:bg-blue-600">
            Reschedule
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
